window.customElements.define('quantity-selector', class QuantitySelector extends HTMLElement {
  constructor() {
    super()
    this.updateDiscountPrices()

    this.input = this.querySelector('input[type="number"]')
    this.minusButton = this.querySelector('button[name="minus"]')
    this.minValue = parseInt(this.input.min)
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onValueChange.bind(this))
    this.input.addEventListener('keyup', this.onValueChange.bind(this))
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onValueChange() {
    if (this.input.value > this.minValue) {
      this.minusButton.removeAttribute('disabled')
    } else {
      this.minusButton.setAttribute('disabled', 'disabled')
    }
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value
    const currentButton = event.target.closest('.quantity-selector__button')
    currentButton.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
      this.updateDiscountPrices()
    }
  }

  updateDiscountPrices() {
    let allocatedAmountSummaryLine = 0
    document.querySelectorAll('.cart-item-item').forEach(el => {
      const quantity = parseFloat(el.querySelector('.input-quantity')?.value)
      const priceText = el.querySelector('.item-original-price')?.textContent ?? ''
      if (priceText === '' || isNaN(quantity)) return
      const price = parseFloat(priceText.replace(/[^0-9.-]+/g, ''))
      const allocatedAmount = quantity * price
      const allocatedEl = el.querySelector('.total-original-allocated-amount')
      if (allocatedEl) allocatedEl.textContent = '$' + allocatedAmount.toFixed(2)
      allocatedAmountSummaryLine = allocatedAmount
    })
    const totalEl = document.querySelector('.total-allocated-amount')
    if (totalEl) totalEl.textContent = '$' + allocatedAmountSummaryLine.toFixed(2)
  }
})
